import React, { useState, useEffect } from "react";

export default function InfoPopup() {
  const [visible, setVisible] = useState(false);

  const closeBanner = () => {
    document.body.classList.remove("banner-open");
    setVisible(false);
  };

  useEffect(() => {
    const today = new Date();
    const endDate = new Date("2026-07-25T00:00:00");

    if (today >= endDate) {
      return;
    }

    setVisible(true);
    document.body.classList.add("banner-open");

    const timer = setTimeout(() => {
      closeBanner();
    }, 30000);

    return () => {
      clearTimeout(timer);
      document.body.classList.remove("banner-open");
    };
  }, []);

  if (!visible) return null;

  return (
    <div className="info-banner">
      <div className="info-banner__container">
        <div className="info-banner__left">
          <div className="info-banner__title">📢 Приемная комиссия</div>

          <div className="info-banner__text">
            ГБУ СО «УрНИИДВиИ» объявляет конкурсный набор на обучение в
            ординатуре по специальности 31.08.32 «Дерматовенерология».
            <span className="info-banner__date">
              Прием документов: с 1 июля по 24 июля 2026 года.
            </span>
          </div>
        </div>

        <div className="info-banner__right">
          <a
            href="/education/admissions-committee"
            className="info-banner__button"
          >
            Подробнее
          </a>

          <button
            className="info-banner__close"
            onClick={closeBanner}
            aria-label="Закрыть"
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  );
}
